import { usePersistedLocationState } from "@hooks/usePersistedLocationState";
import { useMemo } from "react";
import type { Ref } from "react";
// eslint-disable-next-line no-restricted-imports -- StateAwareNavLink wraps react-router-dom's NavLink directly
import { NavLink, NavLinkProps } from "react-router-dom";

export const StateAwareNavLink = ({
    ref,
    ...props
}: NavLinkProps & { ref?: Ref<HTMLAnchorElement> }) => {
    const persistedLocationState = usePersistedLocationState();
    const finalState = useMemo(
        () => ({
            ...persistedLocationState,
            ...props.state,
        }),
        [persistedLocationState, props.state],
    );

    return <NavLink {...props} state={finalState} ref={ref} />;
};
